import {allSectors} from 'constants/url';
import axios from 'axios';

async function getAllSectors(token) {
  try {
    const response = await axios.get(`${allSectors}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    return response.data;
  } catch (e) {
    console.error(e);
  }
}

export default getAllSectors;
